var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "wrap" } },
    [
      _c("MainHeader", { attrs: { title: "선물 선택 현황" } }),
      _c(
        "section",
        { staticClass: "selection_present_status" },
        [
          _c("h5", [_vm._v(_vm._s(this.goods.recvr_nm))]),
          _c(
            "ul",
            { staticClass: "product_select_list" },
            _vm._l(_vm.recvrList, function(recvr, i) {
              return _c(
                "li",
                {
                  key: recvr.recvr_no + "-" + i,
                  class: { choice: recvr.goods_sel === 1 },
                  attrs: { item: recvr }
                },
                [
                  _c("div", { staticClass: "func_area" }, [
                    recvr.goods_sel === 1
                      ? _c("span", { staticClass: "tag" }, [_vm._v("선택")])
                      : _vm._e(),
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.$refs.goodDtl.searchGood(
                              _vm.$route.params.event_no,
                              recvr.good_no
                            )
                          }
                        }
                      },
                      [_vm._v("상세보기 ")]
                    )
                  ]),
                  _c("div", { staticClass: "info" }, [
                    _c("div", { staticClass: "thumb" }, [
                      _c("img", {
                        attrs: {
                          src:
                            _vm.$store.getters["systemStore/getImgPath"] +
                            recvr.img_path,
                          alt: _vm.goods.good_nm
                        }
                      })
                    ]),
                    _c("p", { staticClass: "product_name" }, [
                      _vm._v(_vm._s(recvr.good_nm))
                    ])
                  ])
                ]
              )
            }),
            0
          ),
          _c("Footer")
        ],
        1
      ),
      _c("GoodDtl", { ref: "goodDtl", attrs: { price_hidden: true } }),
      _c(
        "button",
        {
          staticClass: "content_btn",
          on: {
            click: function($event) {
              return _vm.$router.push("checkMsgRecept")
            }
          }
        },
        [_vm._v("이 전")]
      ),
      _c("div", { staticClass: "popup check_msg_recept_01" }, [
        _c("div", { staticClass: "popup_container" }, [
          _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
          _c("div", { staticClass: "popup_content" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.alertMsg) } })
          ]),
          _vm._m(0)
        ]),
        _c("div", { staticClass: "dimBg" })
      ]),
      _c("div", { staticClass: "popup check_msg_recept_02" }, [
        _c("div", { staticClass: "popup_container" }, [
          _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
          _c("div", { staticClass: "popup_content" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.alertMsg) } })
          ]),
          _vm._m(1)
        ]),
        _c("div", { staticClass: "dimBg" })
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_button" }, [
      _c(
        "button",
        {
          staticClass: "btn_large",
          attrs: { onclick: "modal('check_msg_recept_01')" }
        },
        [_vm._v("확 인")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_button" }, [
      _c(
        "button",
        { staticClass: "btn_large", attrs: { onclick: "location.reload();" } },
        [_vm._v("확 인")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }